"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iUpdateWorksiteDiaryEntryJobs = exports.iCreateWorksiteDiaryEntry = exports.iWorksiteDiaryEntryJobs = void 0;
const t = require("io-ts");
const _iWorksiteDiaryEntryJobs = t.interface({
    id: t.number,
    entry_id: t.number,
    job_id: t.number,
});
const _iCreateWorksiteDiaryEntryJobs = t.interface({
    id: t.number,
    entry_id: t.number,
    job_id: t.number,
});
const _iUpdateWorksiteDiaryEntryJobs = t.interface({
    id: t.number,
    entry_id: t.number,
    job_id: t.number,
});
exports.iWorksiteDiaryEntryJobs = t.clean(_iWorksiteDiaryEntryJobs);
exports.iCreateWorksiteDiaryEntry = t.clean(_iCreateWorksiteDiaryEntryJobs);
exports.iUpdateWorksiteDiaryEntryJobs = t.clean(_iUpdateWorksiteDiaryEntryJobs);
//# sourceMappingURL=worksiteDiaryEntryJobs.js.map